import React from "react";
import whatsappIcon from "../assets/whatsapp.png";

export default function WhatsAppButton() {
  // Reemplaza "1234567890" con tu número de teléfono en formato internacional
  // Ejemplo: para un número de Colombia (+57 123 456 7890), usa "571234567890"
  const phoneNumber = "593997382016";

  const message = "Hola, quiero solicitar mas información de Parking Club.";
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-icon-ini"
    >
      <img src={whatsappIcon || "/placeholder.svg"} alt="WhatsApp" />
    </a>
  );
}